import * as React from "react";
import { Calendar } from "lucide-react";
import CalendarComponent from "./calendar_component";

interface DateRangePickerProps {
  onDateRangeChange: (dateRange: Date[]) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  onDateRangeChange,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [selectedDates, setSelectedDates] = React.useState<Date[]>([]);
  const [year, setYear] = React.useState<number>(new Date().getFullYear());
  const [month, setMonth] = React.useState<number>(new Date().getMonth());

  const handleDateSelect = (date: Date) => {
    if (selectedDates.length === 0 || selectedDates.length === 2) {
      setSelectedDates([date]);
    } else if (selectedDates.length === 1 && selectedDates[0]) {
      const newDates = [selectedDates[0], date].sort(
        (a, b) => a.getTime() - b.getTime(),
      );
      setSelectedDates(newDates);
      onDateRangeChange(newDates);
      setIsOpen(false);
    }
  };

  const handleMonthChange = (newYear: number, newMonth: number) => {
    setYear(newYear);
    setMonth(newMonth);
  };

  const formatDateRange = (): string => {
    if (selectedDates.length === 0) return "Choose your shooting days";
    if (selectedDates.length === 1 && selectedDates[0])
      return selectedDates[0].toLocaleDateString();
    if (selectedDates.length === 2 && selectedDates[0] && selectedDates[1])
      return `${selectedDates[0].toLocaleDateString()} - ${selectedDates[1].toLocaleDateString()}`;
    return "Choose your shooting days";
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full text-lg font-ubuntu text-grayPass flex items-center justify-between p-4 border rounded-md"
      >
        <span>{formatDateRange()}</span>
        <Calendar size={20} />
      </button>
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full">
          <CalendarComponent
            year={year}
            month={month}
            selectedDates={selectedDates}
            onDateSelect={handleDateSelect}
            onMonthChange={handleMonthChange}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
